import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermsValue } from '../../../packages/JsonQuery';
import { EPlacementType } from '../../../packages/api-models/common/json_query';

export const selectPlacementType = createSelector(
  selectJsonQuery,
  jsonQuery => getTermsValue('placement_type')(jsonQuery) as EPlacementType[] | null,
);
